import {
  Component,
  computed,
  DestroyRef,
  inject,
  input,
  OnInit,
  ChangeDetectionStrategy,
} from '@angular/core';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { interval } from 'rxjs';
import { DurationPipe } from '@app/core/pipes/duration.pipe';

@Component({
  selector: 'ag1-time-since',
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './ag1-time-since.component.html',
})
export class Ag1TimeSinceComponent implements OnInit {
  private destroyRef = inject(DestroyRef);
  private durationPipe = inject(DurationPipe);

  // Inputs
  timestamp = input.required<string>();
  updateInterval = input<number>(5000);
  prefix = input<string>('Data refreshed');
  suffix = input<string>('ago');

  // Interval that emits at the specified rate to trigger UI updates
  private refreshInterval = toSignal(
    interval(this.updateInterval()).pipe(takeUntilDestroyed(this.destroyRef)),
    { initialValue: 0 },
  );

  displayText = computed(() => {
    // Create dependency on refreshInterval to trigger recalculation
    this.refreshInterval();

    if (!this.timestamp()) {
      return null;
    }

    const duration: string = this.durationPipe.transform(this.timestamp());
    return `${this.prefix()} ${duration} ${this.suffix()}`;
  });

  ngOnInit(): void {
    // Trigger initial refreshInterval subscription
    this.refreshInterval();
  }
}
